<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
      };
    },
    mounted() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/index.vue